/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AppointmentAvailabilityList,
    AppointmentAvailabilityListFromJSON,
    AppointmentAvailabilityListToJSON,
    AppointmentCreateParams,
    AppointmentCreateParamsFromJSON,
    AppointmentCreateParamsToJSON,
    AppointmentOption,
    AppointmentOptionFromJSON,
    AppointmentOptionToJSON,
    AppointmentOptionCreateParams,
    AppointmentOptionCreateParamsFromJSON,
    AppointmentOptionCreateParamsToJSON,
    AppointmentOptionList,
    AppointmentOptionListFromJSON,
    AppointmentOptionListToJSON,
    AppointmentOptionUpdateParams,
    AppointmentOptionUpdateParamsFromJSON,
    AppointmentOptionUpdateParamsToJSON,
    AppointmentType,
    AppointmentTypeFromJSON,
    AppointmentTypeToJSON,
    AppointmentTypeCreateParams,
    AppointmentTypeCreateParamsFromJSON,
    AppointmentTypeCreateParamsToJSON,
    AppointmentTypeList,
    AppointmentTypeListFromJSON,
    AppointmentTypeListToJSON,
    AppointmentTypeUpdateParams,
    AppointmentTypeUpdateParamsFromJSON,
    AppointmentTypeUpdateParamsToJSON,
    AppointmentUpdateParams,
    AppointmentUpdateParamsFromJSON,
    AppointmentUpdateParamsToJSON,
    AvailableDateList,
    AvailableDateListFromJSON,
    AvailableDateListToJSON,
    AvailableTimeList,
    AvailableTimeListFromJSON,
    AvailableTimeListToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    ManualRegistrationV2,
    ManualRegistrationV2FromJSON,
    ManualRegistrationV2ToJSON,
    ProgramEventStatus,
    ProgramEventStatusFromJSON,
    ProgramEventStatusToJSON,
    ProgramEventType,
    ProgramEventTypeFromJSON,
    ProgramEventTypeToJSON,
    Registration,
    RegistrationFromJSON,
    RegistrationToJSON,
    RegistrationList,
    RegistrationListFromJSON,
    RegistrationListToJSON,
    RegistrationStatus,
    RegistrationStatusFromJSON,
    RegistrationStatusToJSON,
    ScheduleAppointment,
    ScheduleAppointmentFromJSON,
    ScheduleAppointmentToJSON,
    ScheduledAppointmentCreateParamsV2,
    ScheduledAppointmentCreateParamsV2FromJSON,
    ScheduledAppointmentCreateParamsV2ToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface AbandonAppointmentRequest {
    program_id: string;
    registration_id: string;
}

export interface CancelAppointmentRequest {
    program_id: string;
    registration_id: string;
}

export interface CreateAppointmentRequest {
    program_id: string;
    AppointmentCreateParams: AppointmentCreateParams;
}

export interface CreateAppointmentOptionRequest {
    program_id: string;
    appointment_type_id: string;
    AppointmentOptionCreateParams: AppointmentOptionCreateParams;
}

export interface CreateAppointmentTypeRequest {
    program_id: string;
    AppointmentTypeCreateParams: AppointmentTypeCreateParams;
}

export interface CreateScheduleAppointmentRequest {
    program_id: string;
    ScheduleAppointment: ScheduleAppointment;
}

export interface CreateScheduleAppointmentV2Request {
    program_id: string;
    ScheduledAppointmentCreateParamsV2: ScheduledAppointmentCreateParamsV2;
}

export interface DeleteAppointmentOptionRequest {
    program_id: string;
    appointment_type_id: string;
    option_id: string;
}

export interface DeleteAppointmentTypeRequest {
    program_id: string;
    appointment_type_id: string;
}

export interface FindAppointmentAvailabilitysRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    type?: Array<ProgramEventType>;
    status?: Array<ProgramEventStatus>;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
}

export interface FindAppointmentOptionsRequest {
    program_id: string;
    appointment_type_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindAppointmentTypeRegistrationsRequest {
    program_id: string;
    appointment_type_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    status?: Array<RegistrationStatus>;
    program_attendee_id?: string;
    event_scheduled_lt?: Date;
    event_scheduled_gt?: Date;
    event_scheduled_lte?: Date;
    event_scheduled_gte?: Date;
}

export interface FindAppointmentTypesRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    type?: Array<ProgramEventType>;
    status?: Array<ProgramEventStatus>;
    scheduled_lt?: Date;
    scheduled_gt?: Date;
    scheduled_lte?: Date;
    scheduled_gte?: Date;
}

export interface FindDatesAppointmentAvailabilityRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    month?: Date;
    appointment_option_id?: string;
    appointment_type_id?: string;
    reschedule_id?: string;
}

export interface FindOneAppointmentRequest {
    program_id: string;
    registration_id: string;
}

export interface FindOneAppointmentOptionRequest {
    program_id: string;
    appointment_type_id: string;
    option_id: string;
}

export interface FindOneAppointmentTypeRequest {
    program_id: string;
    appointment_type_id: string;
}

export interface FindTimesAppointmentAvailabilityRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    date?: Date;
    appointment_option_id?: string;
    appointment_type_id?: string;
    reschedule_id?: string;
}

export interface PublishAppointmentTypeRequest {
    program_id: string;
    appointment_type_id: string;
}

export interface RefundAppointmentRequest {
    program_id: string;
    registration_id: string;
}

export interface UnpublishAppointmentTypeRequest {
    program_id: string;
    appointment_type_id: string;
}

export interface UpdateAppointmentRequest {
    program_id: string;
    registration_id: string;
    AppointmentUpdateParams: AppointmentUpdateParams;
}

export interface UpdateAppointmentOptionRequest {
    program_id: string;
    appointment_type_id: string;
    option_id: string;
    AppointmentOptionUpdateParams: AppointmentOptionUpdateParams;
}

export interface UpdateAppointmentTypeRequest {
    program_id: string;
    appointment_type_id: string;
    AppointmentTypeUpdateParams: AppointmentTypeUpdateParams;
}

/**
 * 
 */
export class AppointmentsApi extends runtime.BaseAPI {

    /**
     * Abandon a registration for appointment
     */
    async abandonAppointmentRaw(requestParameters: AbandonAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling abandonAppointment.');
        }

        if (requestParameters.registration_id === null || requestParameters.registration_id === undefined) {
            throw new runtime.RequiredError('registration_id','Required parameter requestParameters.registration_id was null or undefined when calling abandonAppointment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointments/{registration_id}/abandon`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"registration_id"}}`, encodeURIComponent(String(requestParameters.registration_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Abandon a registration for appointment
     */
    async abandonAppointment(requestParameters: AbandonAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.abandonAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel an appointment
     */
    async cancelAppointmentRaw(requestParameters: CancelAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling cancelAppointment.');
        }

        if (requestParameters.registration_id === null || requestParameters.registration_id === undefined) {
            throw new runtime.RequiredError('registration_id','Required parameter requestParameters.registration_id was null or undefined when calling cancelAppointment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointments/{registration_id}/cancel`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"registration_id"}}`, encodeURIComponent(String(requestParameters.registration_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Cancel an appointment
     */
    async cancelAppointment(requestParameters: CancelAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.cancelAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an appointment
     */
    async createAppointmentRaw(requestParameters: CreateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createAppointment.');
        }

        if (requestParameters.AppointmentCreateParams === null || requestParameters.AppointmentCreateParams === undefined) {
            throw new runtime.RequiredError('AppointmentCreateParams','Required parameter requestParameters.AppointmentCreateParams was null or undefined when calling createAppointment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointments`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentCreateParamsToJSON(requestParameters.AppointmentCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Create an appointment
     */
    async createAppointment(requestParameters: CreateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.createAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create appointment option
     */
    async createAppointmentOptionRaw(requestParameters: CreateAppointmentOptionRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentOption>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createAppointmentOption.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling createAppointmentOption.');
        }

        if (requestParameters.AppointmentOptionCreateParams === null || requestParameters.AppointmentOptionCreateParams === undefined) {
            throw new runtime.RequiredError('AppointmentOptionCreateParams','Required parameter requestParameters.AppointmentOptionCreateParams was null or undefined when calling createAppointmentOption.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}/options`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentOptionCreateParamsToJSON(requestParameters.AppointmentOptionCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentOptionFromJSON(jsonValue));
    }

    /**
     * Create appointment option
     */
    async createAppointmentOption(requestParameters: CreateAppointmentOptionRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentOption> {
        const response = await this.createAppointmentOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create appointment type
     */
    async createAppointmentTypeRaw(requestParameters: CreateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentType>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createAppointmentType.');
        }

        if (requestParameters.AppointmentTypeCreateParams === null || requestParameters.AppointmentTypeCreateParams === undefined) {
            throw new runtime.RequiredError('AppointmentTypeCreateParams','Required parameter requestParameters.AppointmentTypeCreateParams was null or undefined when calling createAppointmentType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentTypeCreateParamsToJSON(requestParameters.AppointmentTypeCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeFromJSON(jsonValue));
    }

    /**
     * Create appointment type
     */
    async createAppointmentType(requestParameters: CreateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentType> {
        const response = await this.createAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * @deprecated Create a scheduled appointment
     */
    async createScheduleAppointmentRaw(requestParameters: CreateScheduleAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createScheduleAppointment.');
        }

        if (requestParameters.ScheduleAppointment === null || requestParameters.ScheduleAppointment === undefined) {
            throw new runtime.RequiredError('ScheduleAppointment','Required parameter requestParameters.ScheduleAppointment was null or undefined when calling createScheduleAppointment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/schedule_appointments`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduleAppointmentToJSON(requestParameters.ScheduleAppointment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * @deprecated Create a scheduled appointment
     */
    async createScheduleAppointment(requestParameters: CreateScheduleAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.createScheduleAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a scheduled appointment
     */
    async createScheduleAppointmentV2Raw(requestParameters: CreateScheduleAppointmentV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ManualRegistrationV2>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createScheduleAppointmentV2.');
        }

        if (requestParameters.ScheduledAppointmentCreateParamsV2 === null || requestParameters.ScheduledAppointmentCreateParamsV2 === undefined) {
            throw new runtime.RequiredError('ScheduledAppointmentCreateParamsV2','Required parameter requestParameters.ScheduledAppointmentCreateParamsV2 was null or undefined when calling createScheduleAppointmentV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/programs/{program_id}/schedule_appointments`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduledAppointmentCreateParamsV2ToJSON(requestParameters.ScheduledAppointmentCreateParamsV2),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManualRegistrationV2FromJSON(jsonValue));
    }

    /**
     * Create a scheduled appointment
     */
    async createScheduleAppointmentV2(requestParameters: CreateScheduleAppointmentV2Request, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ManualRegistrationV2> {
        const response = await this.createScheduleAppointmentV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete appointment option
     */
    async deleteAppointmentOptionRaw(requestParameters: DeleteAppointmentOptionRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteAppointmentOption.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling deleteAppointmentOption.');
        }

        if (requestParameters.option_id === null || requestParameters.option_id === undefined) {
            throw new runtime.RequiredError('option_id','Required parameter requestParameters.option_id was null or undefined when calling deleteAppointmentOption.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}/options/{option_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))).replace(`{${"option_id"}}`, encodeURIComponent(String(requestParameters.option_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete appointment option
     */
    async deleteAppointmentOption(requestParameters: DeleteAppointmentOptionRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteAppointmentOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an appointment type for program
     */
    async deleteAppointmentTypeRaw(requestParameters: DeleteAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteAppointmentType.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling deleteAppointmentType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete an appointment type for program
     */
    async deleteAppointmentType(requestParameters: DeleteAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List availability for an appointment
     */
    async findAppointmentAvailabilitysRaw(requestParameters: FindAppointmentAvailabilitysRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentAvailabilityList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findAppointmentAvailabilitys.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/availability`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentAvailabilityListFromJSON(jsonValue));
    }

    /**
     * List availability for an appointment
     */
    async findAppointmentAvailabilitys(requestParameters: FindAppointmentAvailabilitysRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentAvailabilityList> {
        const response = await this.findAppointmentAvailabilitysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all appointment options
     */
    async findAppointmentOptionsRaw(requestParameters: FindAppointmentOptionsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentOptionList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findAppointmentOptions.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling findAppointmentOptions.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}/options`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentOptionListFromJSON(jsonValue));
    }

    /**
     * List all appointment options
     */
    async findAppointmentOptions(requestParameters: FindAppointmentOptionsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentOptionList> {
        const response = await this.findAppointmentOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all registrations by appointment type
     */
    async findAppointmentTypeRegistrationsRaw(requestParameters: FindAppointmentTypeRegistrationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<RegistrationList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findAppointmentTypeRegistrations.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling findAppointmentTypeRegistrations.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.program_attendee_id !== undefined) {
            queryParameters['program_attendee_id'] = requestParameters.program_attendee_id;
        }

        if (requestParameters.event_scheduled_lt !== undefined) {
            queryParameters['event_scheduled_lt'] = (requestParameters.event_scheduled_lt as any).toISOString();
        }

        if (requestParameters.event_scheduled_gt !== undefined) {
            queryParameters['event_scheduled_gt'] = (requestParameters.event_scheduled_gt as any).toISOString();
        }

        if (requestParameters.event_scheduled_lte !== undefined) {
            queryParameters['event_scheduled_lte'] = (requestParameters.event_scheduled_lte as any).toISOString();
        }

        if (requestParameters.event_scheduled_gte !== undefined) {
            queryParameters['event_scheduled_gte'] = (requestParameters.event_scheduled_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}/registrations`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationListFromJSON(jsonValue));
    }

    /**
     * List all registrations by appointment type
     */
    async findAppointmentTypeRegistrations(requestParameters: FindAppointmentTypeRegistrationsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<RegistrationList> {
        const response = await this.findAppointmentTypeRegistrationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all appointment types
     */
    async findAppointmentTypesRaw(requestParameters: FindAppointmentTypesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentTypeList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findAppointmentTypes.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.type) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.scheduled_lt !== undefined) {
            queryParameters['scheduled_lt'] = (requestParameters.scheduled_lt as any).toISOString();
        }

        if (requestParameters.scheduled_gt !== undefined) {
            queryParameters['scheduled_gt'] = (requestParameters.scheduled_gt as any).toISOString();
        }

        if (requestParameters.scheduled_lte !== undefined) {
            queryParameters['scheduled_lte'] = (requestParameters.scheduled_lte as any).toISOString();
        }

        if (requestParameters.scheduled_gte !== undefined) {
            queryParameters['scheduled_gte'] = (requestParameters.scheduled_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeListFromJSON(jsonValue));
    }

    /**
     * List all appointment types
     */
    async findAppointmentTypes(requestParameters: FindAppointmentTypesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentTypeList> {
        const response = await this.findAppointmentTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List available dates for month
     */
    async findDatesAppointmentAvailabilityRaw(requestParameters: FindDatesAppointmentAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AvailableDateList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findDatesAppointmentAvailability.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.month !== undefined) {
            queryParameters['month'] = (requestParameters.month as any).toISOString();
        }

        if (requestParameters.appointment_option_id !== undefined) {
            queryParameters['appointment_option_id'] = requestParameters.appointment_option_id;
        }

        if (requestParameters.appointment_type_id !== undefined) {
            queryParameters['appointment_type_id'] = requestParameters.appointment_type_id;
        }

        if (requestParameters.reschedule_id !== undefined) {
            queryParameters['reschedule_id'] = requestParameters.reschedule_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/availability/dates`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AvailableDateListFromJSON(jsonValue));
    }

    /**
     * List available dates for month
     */
    async findDatesAppointmentAvailability(requestParameters: FindDatesAppointmentAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AvailableDateList> {
        const response = await this.findDatesAppointmentAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find appointment by id
     */
    async findOneAppointmentRaw(requestParameters: FindOneAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneAppointment.');
        }

        if (requestParameters.registration_id === null || requestParameters.registration_id === undefined) {
            throw new runtime.RequiredError('registration_id','Required parameter requestParameters.registration_id was null or undefined when calling findOneAppointment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointments/{registration_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"registration_id"}}`, encodeURIComponent(String(requestParameters.registration_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Find appointment by id
     */
    async findOneAppointment(requestParameters: FindOneAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.findOneAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find appointment option by id
     */
    async findOneAppointmentOptionRaw(requestParameters: FindOneAppointmentOptionRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentOption>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneAppointmentOption.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling findOneAppointmentOption.');
        }

        if (requestParameters.option_id === null || requestParameters.option_id === undefined) {
            throw new runtime.RequiredError('option_id','Required parameter requestParameters.option_id was null or undefined when calling findOneAppointmentOption.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}/options/{option_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))).replace(`{${"option_id"}}`, encodeURIComponent(String(requestParameters.option_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentOptionFromJSON(jsonValue));
    }

    /**
     * Find appointment option by id
     */
    async findOneAppointmentOption(requestParameters: FindOneAppointmentOptionRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentOption> {
        const response = await this.findOneAppointmentOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find appointment type by id
     */
    async findOneAppointmentTypeRaw(requestParameters: FindOneAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentType>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneAppointmentType.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling findOneAppointmentType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeFromJSON(jsonValue));
    }

    /**
     * Find appointment type by id
     */
    async findOneAppointmentType(requestParameters: FindOneAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentType> {
        const response = await this.findOneAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List available times for date
     */
    async findTimesAppointmentAvailabilityRaw(requestParameters: FindTimesAppointmentAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AvailableTimeList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findTimesAppointmentAvailability.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = (requestParameters.date as any).toISOString();
        }

        if (requestParameters.appointment_option_id !== undefined) {
            queryParameters['appointment_option_id'] = requestParameters.appointment_option_id;
        }

        if (requestParameters.appointment_type_id !== undefined) {
            queryParameters['appointment_type_id'] = requestParameters.appointment_type_id;
        }

        if (requestParameters.reschedule_id !== undefined) {
            queryParameters['reschedule_id'] = requestParameters.reschedule_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/availability/times`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AvailableTimeListFromJSON(jsonValue));
    }

    /**
     * List available times for date
     */
    async findTimesAppointmentAvailability(requestParameters: FindTimesAppointmentAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AvailableTimeList> {
        const response = await this.findTimesAppointmentAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Publish an appointment type for program
     */
    async publishAppointmentTypeRaw(requestParameters: PublishAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentType>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling publishAppointmentType.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling publishAppointmentType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}/publish`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeFromJSON(jsonValue));
    }

    /**
     * Publish an appointment type for program
     */
    async publishAppointmentType(requestParameters: PublishAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentType> {
        const response = await this.publishAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refund a registration for event
     */
    async refundAppointmentRaw(requestParameters: RefundAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling refundAppointment.');
        }

        if (requestParameters.registration_id === null || requestParameters.registration_id === undefined) {
            throw new runtime.RequiredError('registration_id','Required parameter requestParameters.registration_id was null or undefined when calling refundAppointment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointments/{registration_id}/refund`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"registration_id"}}`, encodeURIComponent(String(requestParameters.registration_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Refund a registration for event
     */
    async refundAppointment(requestParameters: RefundAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.refundAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unpublish an appointment type for program
     */
    async unpublishAppointmentTypeRaw(requestParameters: UnpublishAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentType>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling unpublishAppointmentType.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling unpublishAppointmentType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}/unpublish`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeFromJSON(jsonValue));
    }

    /**
     * Unpublish an appointment type for program
     */
    async unpublishAppointmentType(requestParameters: UnpublishAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentType> {
        const response = await this.unpublishAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an appointment
     */
    async updateAppointmentRaw(requestParameters: UpdateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Registration>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateAppointment.');
        }

        if (requestParameters.registration_id === null || requestParameters.registration_id === undefined) {
            throw new runtime.RequiredError('registration_id','Required parameter requestParameters.registration_id was null or undefined when calling updateAppointment.');
        }

        if (requestParameters.AppointmentUpdateParams === null || requestParameters.AppointmentUpdateParams === undefined) {
            throw new runtime.RequiredError('AppointmentUpdateParams','Required parameter requestParameters.AppointmentUpdateParams was null or undefined when calling updateAppointment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointments/{registration_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"registration_id"}}`, encodeURIComponent(String(requestParameters.registration_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentUpdateParamsToJSON(requestParameters.AppointmentUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegistrationFromJSON(jsonValue));
    }

    /**
     * Update an appointment
     */
    async updateAppointment(requestParameters: UpdateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Registration> {
        const response = await this.updateAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update appointment option
     */
    async updateAppointmentOptionRaw(requestParameters: UpdateAppointmentOptionRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentOption>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateAppointmentOption.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling updateAppointmentOption.');
        }

        if (requestParameters.option_id === null || requestParameters.option_id === undefined) {
            throw new runtime.RequiredError('option_id','Required parameter requestParameters.option_id was null or undefined when calling updateAppointmentOption.');
        }

        if (requestParameters.AppointmentOptionUpdateParams === null || requestParameters.AppointmentOptionUpdateParams === undefined) {
            throw new runtime.RequiredError('AppointmentOptionUpdateParams','Required parameter requestParameters.AppointmentOptionUpdateParams was null or undefined when calling updateAppointmentOption.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}/options/{option_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))).replace(`{${"option_id"}}`, encodeURIComponent(String(requestParameters.option_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentOptionUpdateParamsToJSON(requestParameters.AppointmentOptionUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentOptionFromJSON(jsonValue));
    }

    /**
     * Update appointment option
     */
    async updateAppointmentOption(requestParameters: UpdateAppointmentOptionRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentOption> {
        const response = await this.updateAppointmentOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update appointment type
     */
    async updateAppointmentTypeRaw(requestParameters: UpdateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<AppointmentType>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateAppointmentType.');
        }

        if (requestParameters.appointment_type_id === null || requestParameters.appointment_type_id === undefined) {
            throw new runtime.RequiredError('appointment_type_id','Required parameter requestParameters.appointment_type_id was null or undefined when calling updateAppointmentType.');
        }

        if (requestParameters.AppointmentTypeUpdateParams === null || requestParameters.AppointmentTypeUpdateParams === undefined) {
            throw new runtime.RequiredError('AppointmentTypeUpdateParams','Required parameter requestParameters.AppointmentTypeUpdateParams was null or undefined when calling updateAppointmentType.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/appointment_types/{appointment_type_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"appointment_type_id"}}`, encodeURIComponent(String(requestParameters.appointment_type_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentTypeUpdateParamsToJSON(requestParameters.AppointmentTypeUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentTypeFromJSON(jsonValue));
    }

    /**
     * Update appointment type
     */
    async updateAppointmentType(requestParameters: UpdateAppointmentTypeRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<AppointmentType> {
        const response = await this.updateAppointmentTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
